import apiClient from "./apiService";
// import debugService from "./debugService";

const USER_TOKEN_KEY = "widget_user_token";

export interface WidgetUser {
  id: number;
  name: string;
  email: string;
  token: string;
  created_at: string;
  auth_provider: string;
}

export interface UserRegisterRequest {
  name: string;
  email: string;
  auth_provider?: string;
  provider_id?: string;
}

export const userAuthService = {
  /**
   * Регистрирует пользователя в системе виджета
   * @param userData Имя и email пользователя
   * @returns Promise с данными пользователя, включая токен
   */
  register: async (userData: UserRegisterRequest): Promise<WidgetUser> => {
    try {
      // debugService.info("Registering widget user", {
      //   name: userData.name,
      //   email: userData.email,
      // });

      const response = await apiClient.post<WidgetUser>(
        "widget/register",
        userData
      );

      // Сохраняем данные пользователя в localStorage
      localStorage.setItem(USER_TOKEN_KEY, JSON.stringify(response.data));

      // debugService.info("User registered successfully", {
      //   userId: response.data.id,
      //   authProvider: response.data.auth_provider,
      // });

      return response.data;
    } catch (error) {
      console.log("Error registering user: ", error);
      // debugService.error("Error registering user", { error });
      throw error;
    }
  },

  /**
   * Получает токен текущего пользователя
   * @returns Токен пользователя или null, если не авторизован
   */
  getUserToken: (): string | null => {
    const userData = localStorage.getItem(USER_TOKEN_KEY);
    if (!userData) return null;

    try {
      const user: WidgetUser = JSON.parse(userData);
      return user.token;
    } catch (error) {
      console.log("Error parsing user data: ", error);
      //  debugService.error("Error parsing user data", { error });
      return null;
    }
  },

  /**
   * Проверяет, есть ли данные пользователя в локальном хранилище
   * @returns true, если данные пользователя существуют
   */
  hasUserData: (): boolean => {
    return localStorage.getItem(USER_TOKEN_KEY) !== null;
  },

  /**
   * Получает сохраненные данные пользователя, если они доступны
   * @returns Данные пользователя или null
   */
  getUserData: (): WidgetUser | null => {
    const userData = localStorage.getItem(USER_TOKEN_KEY);
    if (!userData) return null;

    try {
      return JSON.parse(userData);
    } catch (error) {
      console.log("Error parsing user data: ", error);
      // debugService.error("Error parsing user data", { error });
      return null;
    }
  },

  /**
   * Очищает данные аутентификации пользователя
   */
  clearUserAuth: (): void => {
    localStorage.removeItem(USER_TOKEN_KEY);
  },

  /**
   * Обеспечивает аутентификацию пользователя и возвращает токен
   * Если пользователь не аутентифицирован, пытается зарегистрировать его с предоставленными данными
   * @param userData Данные регистрации пользователя
   * @returns Promise с токеном пользователя
   */
  ensureAuthenticated: async (
    userData: UserRegisterRequest
  ): Promise<string> => {
    // Проверяем, есть ли у нас уже данные пользователя
    if (userAuthService.hasUserData()) {
      const token = userAuthService.getUserToken();
      if (token) return token;
    }

    // Если нет, регистрируем пользователя
    try {
      const user = await userAuthService.register(userData);
      return user.token;
    } catch (error) {
      console.log("Failed to authenticate user: ", error);
      //  debugService.error("Failed to authenticate user", { error, userData });
      throw new Error(
        "Не удалось авторизовать пользователя. Пожалуйста, попробуйте еще раз."
      );
    }
  },
};

export default userAuthService;
